import { render, staticRenderFns } from "./MpSortingV2.vue?vue&type=template&id=8808ff40&scoped=true&"
import script from "./MpSortingV2.vue?vue&type=script&lang=js&"
export * from "./MpSortingV2.vue?vue&type=script&lang=js&"
import style1 from "./MpSortingV2.vue?vue&type=style&index=1&id=8808ff40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808ff40",
  null
  
)

export default component.exports